import { render, staticRenderFns } from "./WorkIconTag.vue?vue&type=template&id=380cf34e"
import script from "./WorkIconTag.vue?vue&type=script&lang=js"
export * from "./WorkIconTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports